import { extractIdFromIri } from "./extractFromIri";
import { iriLast } from "./iriLast";

function pickLocalizedText(value, lang = "en") {
  if (!value) return "";

  if (Array.isArray(value)) {
    const exact =
      value.find((item) => (item?.language ?? item?.lang) === lang) ??
      value.find((item) => (item?.language ?? item?.lang) === "en") ??
      value[0];

    return (
      exact?.value ??
      exact?.text ??
      exact?.label ??
      exact?.name ??
      ""
    );
  }

  if (typeof value === "string") return value;

  if (typeof value === "object") {
    return value?.value ?? value?.text ?? value?.label ?? value?.name ?? "";
  }

  return "";
}

function getParticipantLookupKeys(value) {
  const normalized = String(value ?? "").trim();
  if (!normalized || normalized === "-") return [];

  return [
    ...new Set([normalized, extractIdFromIri(normalized), iriLast(normalized)]),
  ].filter(Boolean);
}

function getParticipantLookupId(participant) {
  if (!participant || typeof participant !== "object") return "";

  return (
    participant?.dsbParticipantId ??
    participant?.participant_id ??
    extractIdFromIri(participant?.id) ??
    participant?.id ??
    participant?.identifier?.[0]?.notation ??
    participant?.externalIdentifier ??
    ""
  );
}

function getParticipantDisplayLabel(participant, lang = "en") {
  if (!participant || typeof participant !== "object") return "";

  return (
    pickLocalizedText(participant?.preferredLabel, lang) ||
    pickLocalizedText(participant?.identifier?.[0]?.schemeName, lang) ||
    participant?.identifier?.[0]?.notation ||
    ""
  );
}

export function buildParticipantsById(participants = []) {
  return (Array.isArray(participants) ? participants : []).reduce(
    (acc, participant) => {
      const participantId = getParticipantLookupId(participant);

      getParticipantLookupKeys(participantId).forEach((key) => {
        acc[key] = participant;
      });

      return acc;
    },
    {},
  );
}

export function getParticipantLabelById(
  participantId,
  participantsById,
  lang = "en",
) {
  const fallback =
    extractIdFromIri(participantId) || String(participantId ?? "").trim() || "-";

  for (const key of getParticipantLookupKeys(participantId)) {
    const displayLabel = getParticipantDisplayLabel(participantsById[key], lang);

    if (displayLabel) return displayLabel;
  }

  return fallback;
}
